import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { router } from '@/core/routes'
import { readStoredTheme } from '@/core/stores/theme.store'

import './index.css'

// İlk boyada doğru temayı uygula (klasik/canli flaş'ını önle). Kalıcı tercih
// localStorage'da; yoksa 'klasik'. Store da aynı kaynaktan başlatılır.
document.documentElement.dataset.theme = readStoredTheme()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element bulunamadı')
}

createRoot(rootElement).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
